<script setup>
import { computed } from 'vue';
import ContextMenu from 'dashboard/components/ui/ContextMenu.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const props = defineProps({
  contextMenuPosition: {
    type: Object,
    default: () => ({}),
  },
  menuItems: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['close', 'selectAction']);

// The shared kit DropdownMenu reads `action` (the destructive color keys off 'delete').
const items = computed(() =>
  props.menuItems.map(({ key, ...item }) => ({ ...item, action: key }))
);

const handleClose = () => {
  emit('close');
};

const onMenuItemClick = ({ action }) => {
  emit('selectAction', action);
  handleClose();
};
</script>

<template>
  <ContextMenu
    :x="contextMenuPosition.x"
    :y="contextMenuPosition.y"
    @close="handleClose"
  >
    <DropdownMenu
      :menu-items="items"
      class="!static w-48"
      @action="onMenuItemClick"
      @click.stop
    />
  </ContextMenu>
</template>
